import ListPageView from "../../components/ListPageView"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"
import ActivityLogSidebar from "../../components/sidebars/ActivityLogSidebar"

export default function PJR() {
  const ID_TEMPLATE = "pjr_activity_log"
  const ID_BLOCKS = ["activity__pjr", "activity"]
  const disableFilter = true

  const listViewCols = [
    {
      header: "Date",
      field: "activity_date",
      block: "activity",
      type: "date",
    },
    {
      header: "Curriculum",
      field: "activity_curriculum_type_week_pjr-A",
      block: "activity__pjr",
      type: "type_curriculum",
    },
    {
      header: "Week of curriculum",
      field: "activity_curriculum_type_week_pjr",
      block: "activity__pjr",
      type: "week_curriculum",
    },
    {
      header: "Attendees",
      field: "activity_attendance_pjr",
      block: "activity__pjr",
      type: "string",
    },
    {
      header: "Child Care Assistance",
      field: "activity_attendance_child_care_pjr",
      block: "activity__pjr",
      type: "string",
    },
    {
      header: "Transportation Assistance",
      field: "activity_attendance_transportation_pjr",
      block: "activity__pjr",
      type: "string",
    },
    {
      header: "Program ID",
      field: "activity__program_identity_ids",
      block: "activity",
      type: "program",
    },
  ]

  return (
    <>
      <PageSidebarContent>
        <ActivityLogSidebar />
      </PageSidebarContent>
      <div className="main-content">
        <ListPageView
          idTemplate={ID_TEMPLATE}
          idBlocks={ID_BLOCKS}
          columns={listViewCols}
          disableFilter={disableFilter}
        />
      </div>
    </>
  )
}
